import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../utils/translations';
import Container from '../common/Container';
import Button from '../common/Button';
import useTypingEffect from '../../hooks/useTypingEffect';
import '../../styles/Hero.css';
import perfilImage from "../../assets/Profile/perfil.jpeg";
import { FaLinkedin, FaGithub, FaFileAlt} from "react-icons/fa";
import CV_ES from "../../assets/pdf/cv/es.pdf";
import CV_EN from "../../assets/pdf/cv/en.pdf";

const Hero = () => {
    const { theme } = useTheme();
    const { language } = useLanguage();
    const t = translations[language].hero;
    const typingRef = useTypingEffect(t.roles, language);
    const CV = language === 'es' ? CV_ES : CV_EN;

    return (
        <section id="hero" className={`hero ${theme}`}>
            <div className="hero-background"></div>
            <Container>
                <div className="hero-content">
                    <div className="hero-text">
                        <div className="hero-intro">{t.greeting}</div>
                        <h1 className="hero-name fade-in">{t.name}</h1>
                        <div className="hero-role">
                            <span>{t.prefix}</span>
                            <span ref={typingRef} className="typing-text"></span>
                            <span className="typing-cursor">|</span>
                        </div>
                        <p className="hero-description">
                            {t.description}
                        </p>
                        <div className="hero-buttons">
                            <Button
                                variant="primary"
                                size="large"
                                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                            >
                                {t.buttons.contact}
                            </Button>
                            <Button
                                variant="secondary"
                                size="large"
                                onClick={() => document.getElementById('projects').scrollIntoView({ behavior: 'smooth' })}
                            >
                                {t.buttons.projects}
                            </Button>
                        </div>
                        <div className="hero-social">
                            <a href="https://github.com/ErickTorres6412" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <FaGithub />
                            </a>
                            <a href="https://www.linkedin.com/in/erick7314/" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <FaLinkedin />
                            </a>
                            <a href={CV} target="_blank" rel="noopener noreferrer" className="social-icon">
                                <FaFileAlt />
                            </a>
                        </div>
                    </div>
                    <div className="hero-image">
                        <div className="profile-image-container">
                            <img
                                src={perfilImage}
                                alt={`${t.name} - ${t.roles[0]}`}
                                className="profile-image"
                            />
                            <div className="profile-backdrop"></div>
                        </div>
                    </div>
                </div>
            </Container>
            <div className="scroll-indicator">
                <div className="mouse">
                    <div className="wheel"></div>
                </div>
                <div className="scroll-arrow">
                    <span className="arrow-down"></span>
                </div>
            </div>
        </section>
    );
};

export default Hero;